import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { User as UserIcon, Share2 } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../base/tooltip/tooltip";
const MODE_ICONS = {
    manual: UserIcon,
    viral: Share2
};
const BASE_CLASSES = "relative flex flex-1 items-center justify-center gap-1.5 px-2.5 py-1.5 rounded-lg text-sm font-semibold";
function variantClasses(isActive, isDisabled) {
    if (isActive) return "bg-[#fff9e9] text-black";
    if (isDisabled) return "text-fg-disabled cursor-not-allowed";
    return "text-gray-5";
}
/**
 * Pill toggle for switching a draft step between manual and viral (assignment)
 * modes. Disabled segments stay visible but inert; hovering/focusing them
 * reveals a tooltip explaining the gate.
 */ export function StepModeSwitch({ mode, onChange, labels, disabledReason }) {
    const segments = [
        {
            value: "manual",
            label: labels.manual,
            reason: disabledReason?.manual
        },
        {
            value: "viral",
            label: labels.viral,
            reason: disabledReason?.viral
        }
    ];
    return /*#__PURE__*/ _jsx(TooltipProvider, {
        delayDuration: 150,
        children: /*#__PURE__*/ _jsx("div", {
            className: "flex items-center gap-1.5 p-1 bg-white border border-line rounded-xl",
            children: segments.map(({ value, label, reason })=>{
                const isActive = mode === value;
                const isDisabled = Boolean(reason) && !isActive;
                const Icon = MODE_ICONS[value];
                const button = /*#__PURE__*/ _jsxs("button", {
                    type: "button",
                    disabled: isDisabled,
                    onClick: ()=>{
                        if (isActive) return;
                        onChange(value);
                    },
                    className: `${BASE_CLASSES} ${variantClasses(isActive, isDisabled)}`,
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            className: "w-3.5 h-3.5"
                        }),
                        label,
                        isActive && /*#__PURE__*/ _jsx("div", {
                            "aria-hidden": "true",
                            className: "absolute border border-border-7 border-solid inset-0 pointer-events-none rounded-lg"
                        })
                    ]
                }, value);
                if (isDisabled && reason) {
                    // Native disabled buttons swallow pointer events — wrap in a
                    // focusable span so Radix's tooltip trigger still fires.
                    return /*#__PURE__*/ _jsxs(Tooltip, {
                        children: [
                            /*#__PURE__*/ _jsx(TooltipTrigger, {
                                asChild: true,
                                children: /*#__PURE__*/ _jsx("span", {
                                    tabIndex: 0,
                                    className: "flex flex-1",
                                    children: button
                                })
                            }),
                            /*#__PURE__*/ _jsx(TooltipContent, {
                                children: reason
                            })
                        ]
                    }, value);
                }
                return button;
            })
        })
    });
}

//# sourceMappingURL=StepModeSwitch.js.map